export default {
	data: {},
};
